import clsx from "clsx";
import { HTMLProps } from "react";

export type InsightStatusType = "green" | "amber" | "red" | "grey";
type BodyType = HTMLProps<HTMLDivElement> & { status?: InsightStatusType };
export const Body = ({ status, children }: BodyType) => {
  return (
    <div className="flex items-center gap-1 py-1 text-xl font-medium">
      {status && <Status status={status} />}
      {children}
    </div>
  );
};

enum StatusColors {
  green = "bg-positive-500",
  amber = "bg-amber-400",
  red = "bg-red-600",
  grey = "bg-neutral-300",
}
const Status = ({ status }: { status: InsightStatusType }) => {
  return <div className={clsx("rounded-full h-3 w-3 shrink-0", status && StatusColors[status])} />;
};
